/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OnlineMeeting } from './OnlineMeeting';
import type { Payment } from './Payment';
export type BookedClientEvent = {
    start: string;
    end: string;
    bookedAt: string;
    moveRequestedStart: string | null;
    moveRequestedEnd: string | null;
    id: number;
    title: string;
    isConfirmed: boolean;
    pendingClientConfirmation: boolean;
    eventStatus: BookedClientEvent.eventStatus;
    isOutage: boolean;
    location: BookedClientEvent.location;
    price: string;
    taxRate: string;
    outageFeePrice: string | null;
    outageFeeApplies: BookedClientEvent.outageFeeApplies | null;
    categoryId: number;
    onlineMeeting: OnlineMeeting;
    payment: Payment | null;
    moveRequestedLocation: BookedClientEvent.moveRequestedLocation | null;
    moveRequestedMessage: string | null;
    isCreditBooking: boolean;
};
export namespace BookedClientEvent {
    export enum eventStatus {
        OPEN = 'open',
        BOOKED = 'booked',
        ASSIGNED = 'assigned',
        APPROVED = 'approved',
        CANCELLED = 'cancelled',
        REJECTED = 'rejected',
        OUTAGE = 'outage',
        SKIPPED = 'skipped',
        MOVE_REQUESTED = 'move-requested',
    }
    export enum location {
        VIRTUAL = 'virtual',
        ONSITE = 'onsite',
    }
    export enum outageFeeApplies {
        YES = 'yes',
        NO = 'no',
        NOT_SELECTED = 'not-selected',
    }
    export enum moveRequestedLocation {
        VIRTUAL = 'virtual',
        ONSITE = 'onsite',
    }
}

